/*@ngInject*/
const SubmissionPrequalificationMediator = function (prequalificationRepository) {
    this.startPrequalification = function(submissionId) {
        return prequalificationRepository.startPrequalification(submissionId);
    };
    this.cancelPrequalification = function(submissionId) {
        return prequalificationRepository.cancelPrequalification(submissionId);
    };
    this.submitPrequalification = function(submissionId) {
        return prequalificationRepository.submitPrequalification(submissionId);
    };
    this.checkPrequalification = function(submissionId) {
        return prequalificationRepository.checkPrequalification(submissionId);
    };
};

angular.module('gw-um-submission').service('submissionPrequalificationMediator', SubmissionPrequalificationMediator);

